 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML000_COVER from '@/components/xhtml/000_Cover'
 import XHTML001_HALF_TITLE_PAGE from '@/components/xhtml/001_Half_title_page'
 import XHTML002_PROLOGUE from '@/components/xhtml/002_Prologue'
 import XHTML003_TITLE from '@/components/xhtml/003_Title'
 import XHTML004_COPYRIGHT from '@/components/xhtml/004_Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML006_INTRODUCTION from '@/components/xhtml/006_Introduction'
 import XHTML007_LIST_OF_ABBREVIATIONS from '@/components/xhtml/007_List_of_Abbreviations'
 import XHTML008_CHAPTER_1 from '@/components/xhtml/008_Chapter_1'
 import XHTML009_CHAPTER_2 from '@/components/xhtml/009_Chapter_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/006_Introduction",
 			"name" : "xhtml/006_Introduction",
 			"component" : XHTML006_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/007_List_of_Abbreviations",
 			"name" : "xhtml/007_List_of_Abbreviations",
 			"component" : XHTML007_LIST_OF_ABBREVIATIONS
 		},
 		{
 			"path" : "/xhtml/008_Chapter_1",
 			"name" : "xhtml/008_Chapter_1",
 			"component" : XHTML008_CHAPTER_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js